import { projectController } from '@/api';
import styles from './Home.module.less';
import FunCard from './components/FunCard/FunCard';
import funModelImage from '@/assets/home/fun-model.png';
import loadingIcon from '@/assets/loading.gif';
import funTextureImage from '@/assets/home/fun-texture.png';
import projectIcon from '@/assets/home/modelImg.png';
import { useEffect, useRef, useState } from 'react';
import { Modal, Spin } from 'antd';
import GenerateModel from './components/GenerateModel/GenerateModel';
import GenerateTexture from './components/GenerateTexture/GenerateTexture';
import closeIcon from '@/assets/project/closewhite.png';
import { useNavigate } from 'react-router-dom';
import NavigationImg from '@/assets/home/navigation.png'
import NavBtnRightImg from '@/assets/home/navbtnright.svg'
import { useTranslation } from 'react-i18next';

export default function Home() {
  const [list, setList] = useState([]);
  const [pageSize, setPageSize] = useState(8);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);
  const [showGenerateModelModal, setShowGenerateModelModal] = useState(false);
  const [showGenerateTextureModal, setShowGenerateTextureModal] = useState(false);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [noMore, setNoMore] = useState(false);
  const { t } = useTranslation();

  const loader = useRef(null);

  useEffect(() => {
    query();
  }, [page]);
  const query = async () => {
    if (noMore) {
      return;
    }
    setLoading(true);
    const res = await projectController.templateList({
      pageIndex: page,
      pageSize: pageSize,
    });
    if (res.code == 0) {
      setLoading(false);
      if (res.data.records.length === 0) {
        setNoMore(true);
      }
      setTotal(res.data.totalRow);
      setList([...list, ...res.data.records]);
    }
  };

  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting && !loading) {
        setPage(page + 1);
      }
    });

    if (loader.current) observer.observe(loader.current);
    return () => observer.disconnect();
  }, [loading]);

  const clickEditProject = async (project) => {
    const res = await projectController.toPersonal({
      body: {
        squareProjectId: project.id,
        type: 0,
      },
    });
    if (res.code == 0) {
      window.location.href =
        window.location.protocol + '//' + window.location.host + '/texture/' + res.data;
    }
  };
  const clickViewProject = async (project) => {
    const res = await projectController.toPersonal({
      body: {
        squareProjectId: project.id,
        type: 1,
      },
    });
    if (res.code == 0) {
      navigate('/preview/' + res.data);
    }
  };

  const handleClickNavHref = () => {
    window.open('https://tesla.poupiu.com', '_blank');
  };

  return (
    <div className={styles.home}>
      <div className={styles.caption}>{t('app.letsGetStarted')}</div>
      <div className={styles.funcs}>
        <FunCard
          caption={t('app.generate3dModel')}
          buttonTitle={t('app.getStarted')}
          onClick={() => {
            setShowGenerateModelModal(true);
          }}
          image={funModelImage}></FunCard>
        <FunCard
          caption={t('app.generateTexture')}
          onClick={() => {
            setShowGenerateTextureModal(true);
          }}
          buttonTitle={t('app.uploadModel')}
          image={funTextureImage}></FunCard>
      </div>
      <div className={styles.navigation} onClick={handleClickNavHref}>
        <img className={styles.navImg} src={NavigationImg} alt="" />
        <div className={styles.navBox}>
        <div className={styles.navText}>{t('app.teslaTextureGeneration')}</div>
          <div className={styles.navBtn}>
            <span className={styles.btnText}>{t('app.getStarted')}</span>
            <img className={styles.btnRight} src={NavBtnRightImg} alt="" />
          </div>
        </div>
      </div>
      <div className={styles.caption}>
        <div className={styles.icon}></div>
        {t('app.inspirationSquare')}
      </div>
      {/* <Spin style={{ backgroundColor: 'rgb(27,27,27)', marginTop: 20 }} spinning={loading}></Spin> */}

      <div className={styles.list}>
        {list.map((item) => {
          return (
            <div key={item.id} className={styles.item} onClick={() => {}}>
              <div className={styles['project-img-wrapper']}>
                <img className={styles['project-img']} src={item.cover || projectIcon}></img>
                <div
                  className={styles['hover-wrapper']}
                  onClick={(event) => {
                    // event.stopPropagation();
                  }}>
                  <div
                    className={styles['edit']}
                    onClick={(event) => {
                      clickEditProject(item);
                    }}>
                    <div className={styles['icon']}></div>
                    <div className={styles['name']}>{t('app.edit')}</div>
                  </div>
                  <div
                    className={styles['view']}
                    onClick={(event) => {
                      clickViewProject(item);
                    }}>
                    <div className={styles['icon']}></div>
                    <div className={styles['View']}>{t('app.view')}</div>
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
      <div ref={loader} className={styles.loader}>
        {loading ? <img style={{ width: 24, height: 24 }} src={loadingIcon}></img> : ''}
      </div>
      {showGenerateModelModal && (
        <Modal
          open={showGenerateModelModal}
          closeIcon={<img className={'modal-close-icon'} src={closeIcon}></img>}
          wrapClassName="custom-modal"
          onCancel={() => {
            setShowGenerateModelModal(false);
          }}
          footer={<></>}>
          <GenerateModel
            onCancel={() => {
              setShowGenerateModelModal(false);
            }}></GenerateModel>
        </Modal>
      )}

      {showGenerateTextureModal && (
        <Modal
          open={showGenerateTextureModal}
          closeIcon={<img className={'modal-close-icon'} src={closeIcon}></img>}
          wrapClassName="custom-modal"
          onCancel={() => {
            setShowGenerateTextureModal(false);
          }}
          footer={<></>}>
          <GenerateTexture
            onCancel={() => {
              setShowGenerateModelModal(false);
            }}></GenerateTexture>
        </Modal>
      )}
    </div>
  );
}
